import React, { useMemo } from 'react';
import { useMemberApp } from '../AppProvider';
import { personalizedComposerTools } from '../careProfile';
import {
  IconBell,
  IconBookmark,
  IconChart,
  IconChat,
  IconDoc,
  IconHeart,
  IconMic,
  IconPlus,
  IconSearch,
} from './Icons';

const ICONS = {
  bell: IconBell,
  bookmark: IconBookmark,
  chart: IconChart,
  chat: IconChat,
  doc: IconDoc,
  heart: IconHeart,
  mic: IconMic,
  plus: IconPlus,
  search: IconSearch,
};

export default function ToolsMenu({ isPro, onPick }) {
  const { careProfile } = useMemberApp();
  const tools = useMemo(() => personalizedComposerTools(careProfile), [careProfile]);

  return (
    <div className="by-tools" role="menu" aria-label="Tools">
      {tools.map((section) => (
        <div key={section.group} className="by-tools-group">
          <p className="by-tools-label">{section.group}</p>
          {section.items.map((item) => {
            const Icon = ICONS[item.icon] || IconPlus;
            return (
              <button
                key={item.id}
                type="button"
                className="by-tools-item"
                role="menuitem"
                onClick={() => onPick(item)}
              >
                <span className="by-tools-ico" aria-hidden="true">
                  <Icon />
                </span>
                <span className="by-tools-copy">
                  <b>{item.title}</b>
                  <small>{item.detail}</small>
                </span>
                {item.pro && !isPro ? <span className="by-pro">PRO</span> : null}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
